import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { endpoints } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.slice(1));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const u = await endpoints.auth.session(sessionId);
        setUser(u);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(u.onboarding_complete ? "/" : "/onboarding", { replace: true, state: { user: u } });
      } catch (e) {
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#FAFAFA", color: "#737373" }}>
      <div className="text-center">
        <div className="h-8 w-8 mx-auto rounded-full border-2 border-t-transparent animate-spin" style={{ borderColor: "#FAFAFA", borderTopColor: "transparent" }} />
        <p className="mt-4 text-sm mono">Signing you in…</p>
      </div>
    </div>
  );
}
